import axios from "axios";

// constants
import { BASE_URL } from "src/utils/constants";

export const logoutUser = (_accessToken, _userid) => {
  const data = {
    userId: _userid,
    accessToken: _accessToken,
  };

  const response = axios({
    method: "post",
    url: `${BASE_URL()}/Logout`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

  return response;
};
